<nav *ngIf="totalPages > 1" aria-label="Page navigation">
    <ul class="pagination justify-content-center m-0">
        <li class="page-item" [class.disabled]="currentPage === 1">
            <i class="fa-solid fa-chevron-left page-link next" (click)="changePage(currentPage - 1)"></i>
        </li>
        <li *ngFor="let page of pages" class="page-item" [class.active]="page === currentPage">
            <button class="page-link" (click)="changePage(page)">
                <h4>{{ page }}</h4>
            </button>
        </li>
        <li class="page-item" [class.disabled]="currentPage === totalPages">
            <i class="fa-solid fa-chevron-right page-link next" (click)="changePage(currentPage + 1)"></i>
        </li>
    </ul>
</nav>